import React, { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import FirebaseApp from '../config/Firebase';

function Login() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [username, setUsername] = useState('');
  const [showPopup, setShowPopup] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const db = getFirestore(FirebaseApp);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      setShowPopup(false);
      // Check for pending product and navigate if exists
      const pendingProduct = localStorage.getItem('pendingProduct');
      if (pendingProduct) {
        const product = JSON.parse(pendingProduct);
        localStorage.removeItem('pendingProduct'); // Clear pending product
        navigate('/product-details', { state: product });
      } else {
        navigate('/product-details'); // Default navigation if no pending product
      }
    }
  }, [navigate]);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^\d{7,}$/;
    return regex.test(phone);
  };

  const sendWelcomeEmail = async (email, username, phone) => {
    try {
      const response = await fetch(
        'https://aramemail.outliersunited.com/send-new-user-email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, username, phone }),
        }
      );
      if (!response.ok) throw new Error('Failed to send welcome email');
      console.log('Welcome email sent!');
    } catch (error) {
      console.error('Error sending welcome email:', error);
    }
  };

  const handleLoginSignup = async () => {
    if (!email || !username || !phone) {
      alert('Please enter email, username, and phone number.');
      return;
    }
    if (!validateEmail(email)) {
      alert('Please enter a valid email address.');
      return;
    }
    if (!validatePhone(phone)) {
      alert('Please enter a valid phone number (digits only, at least 7 characters).');
      return;
    }
    try {
      const userDocRef = doc(db, 'UID', email);
      const userSnap = await getDoc(userDocRef);
      if (!userSnap.exists()) {
        await setDoc(userDocRef, { email, username, phone });
        await sendWelcomeEmail(email, username, phone);
      }
      const userData = { email, username, phone };
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
      setShowPopup(false);
      // Check for pending product and navigate if exists
      const pendingProduct = localStorage.getItem('pendingProduct');
      if (pendingProduct) {
        const product = JSON.parse(pendingProduct);
        localStorage.removeItem('pendingProduct'); // Clear pending product
        navigate('/product-details', { state: product });
      } else {
        navigate('/product-details'); // Default navigation if no pending product
      }
    } catch (error) {
      console.error('Error during login/signup:', error);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    setShowPopup(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      {showPopup && !user && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-4 w-11/12 max-w-xs">
            <h2 className="text-xl font-bold mb-3 text-center">Login / Signup</h2>
            <input
              type="email"
              placeholder="Email"
              className="w-full mb-2 p-2 border rounded text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              placeholder="Username"
              className="w-full mb-2 p-2 border rounded text-sm"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="text"
              placeholder="Phone"
              className="w-full mb-3 p-2 border rounded text-sm"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <div className="flex justify-between">
              <button
                className="bg-gray-600 text-white px-4 py-2 rounded text-sm"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
              <button
                className="bg-gray-900 text-white px-4 py-2 rounded text-sm"
                onClick={handleLoginSignup}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {user && (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Welcome, {user.username}!</h2>
          <button
            onClick={handleLogout}
            className="bg-gray-900 text-white px-4 py-2 rounded"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default Login;